
(function(){
  'use strict';
  var BASE=[27.99,29.99,32.99,35.99,44.99,49.99,54.99,59.99];
  var PALETTE=[
    ['Navy Blue','#192c55'],['Orange','#f47521'],['White','#f6f6f6'],['Black','#171717'],
    ['Red','#d92133'],['Royal Blue','#164cb0'],['Yellow','#f9cf22'],['Green','#23833b'],
    ['Purple','#732f9c'],['Pink','#f28cb7'],['Gold','#c9a349'],['Silver','#a5aab4'],
    ['Light Blue','#7ac5e8'],['Dark Green','#174f3b'],['Brown','#70472c'],['Gray','#747d87'],
    ['Teal','#20a9a5'],['Cream','#efdfbd']
  ];
  var defaults=['Navy Blue','Orange','White','Black','Red','Royal Blue','Yellow','Green'];
  function colorHex(name){var e=PALETTE.find(function(x){return x[0]===name});return e?e[1]:'#bbc6da';}
  function init(root){
    if(root.dataset.ready==='1')return;root.dataset.ready='1';
    var stage=0,size=5,count=4,quantity=1,chainStyle='Standard Links',chosen=defaults.slice(),file=null,imgURL=null;
    var startingSecondary=true,existingQuantity=Number(root.dataset.cartQuantity)||0,cartFresh=true,cartRequest=null;
    var draftKey='welp-chain-builder-draft-v1',draftReady=false,draftSaved=false,restoredDraft=null,requestedQuantity=null;
    // Carry the chosen homepage quantity tier into Step 1.
    try{
      var initialTier=new URLSearchParams(window.location.search).get('bundle');
      if(initialTier==='2'||initialTier==='5'||initialTier==='10')requestedQuantity=Number(initialTier);
    }catch(e){/* Keep the standard one-chain default if URL parsing is unavailable. */}

    var form=root.querySelector('form'),slides=Array.prototype.slice.call(root.querySelectorAll('[data-w3-step]'));
    var variants=[];try{variants=JSON.parse(root.querySelector('[data-w3-variants]').textContent||'[]');}catch(e){}
    var pick=root.querySelector('[data-w3-picks]'),primary=root.querySelector('[data-w3-primary]'),secondary=root.querySelector('[data-w3-secondary]');
    var input=root.querySelector('[data-w3-artwork]'),notes=root.querySelector('[data-w3-idea]'),detail=root.querySelector('[data-w3-details]');
    var pendant=root.querySelector('[data-w3-pendant]'),chain=root.querySelector('[data-w3-chain]');
    var eventDate=value('event-date');
    function combinedQuantity(){return existingQuantity+quantity;}
    function minNoticeDays(){var q=combinedQuantity();return q<=5?18:q<=9?21:28;}
    function productionDays(){return combinedQuantity()<=5?10:14;}
    function updateSaveStatus(){
      var status=value('save-status');
      if(status)status.textContent=draftSaved?'Selections and written notes are saved in this tab for 24 hours.':'Progress cannot be saved in this browser. Keep this tab open until you add your design to the cart.';
    }
    function saveDraft(){
      if(!draftReady)return;
      try{sessionStorage.setItem(draftKey,JSON.stringify({version:1,savedAt:Date.now(),stage:stage,size:size,count:count,quantity:quantity,chainStyle:chainStyle,chosen:chosen,primary:primary.value,secondary:secondary.value,pendant:pendant.value,idea:notes.value,details:detail.value,eventDate:eventDate&&eventDate.value,hadArtwork:!!file}));draftSaved=true;}catch(e){draftSaved=false;}
      updateSaveStatus();
    }
    function restoreDraft(){
      try{
        var saved=JSON.parse(sessionStorage.getItem(draftKey)||'null');
        if(!saved||saved.version!==1||!Number.isFinite(saved.savedAt)||Date.now()-saved.savedAt>86400000)return;
        if(![5,7].includes(saved.size)||!Number.isInteger(saved.count)||saved.count<1||saved.count>8||!Number.isInteger(saved.quantity)||saved.quantity<1||saved.quantity>24)return;
        if(!['Standard Links','Cuban Links'].includes(saved.chainStyle)||!Array.isArray(saved.chosen)||saved.chosen.length!==8||!saved.chosen.every(function(c){return PALETTE.some(function(p){return p[0]===c;});}))return;
        size=saved.size;count=saved.count;quantity=saved.quantity;chainStyle=saved.chainStyle;chosen=saved.chosen.slice();
        notes.value=typeof saved.idea==='string'?saved.idea.slice(0,500):'';
        detail.value=typeof saved.details==='string'?saved.details:'';
        if(Array.prototype.some.call(pendant.options,function(o){return o.value===saved.pendant;}))pendant.value=saved.pendant;
        if(eventDate&&typeof saved.eventDate==='string'&&/^\d{4}-\d{2}-\d{2}$/.test(saved.eventDate))eventDate.value=saved.eventDate;
        stage=Number.isInteger(saved.stage)?Math.max(0,Math.min(6,saved.stage)):0;
        if(saved.hadArtwork&&!notes.value.trim())stage=Math.min(stage,2);
        restoredDraft=saved;
      }catch(e){}
    }
    function refreshCart(){
      if(cartRequest)return cartRequest;
      cartRequest=fetch(root.dataset.cartUrl||'/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}})
        .then(function(response){if(!response.ok)throw new Error('cart');return response.json();})
        .then(function(cart){existingQuantity=(cart.items||[]).reduce(function(total,item){return total+(Number(item.product_id)===15418083147864||item.handle==='custom-hype-chain-builder'||item.product_handle==='custom-hype-chain-builder'?Number(item.quantity)||0:0);},0);cartFresh=true;refreshPrices();})
        .catch(function(){cartFresh=false;refreshPrices();})
        .finally(function(){cartRequest=null;});
      return cartRequest;
    }
    function earliestNeedByDate(){
      var d=new Date();
      d.setHours(12,0,0,0);
      d.setDate(d.getDate()+minNoticeDays());
      return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
    }
    function updateDateRequirements(){
      var days=minNoticeDays(),minimum=earliestNeedByDate();
      if(eventDate)eventDate.min=minimum;
      setText('min-notice-days',String(days));
      setText('production-window-days',String(productionDays()));
      setText('min-date-example',minimum);
      var notice=value('date-quantity-notice');
      if(notice){
        var selected=eventDate&&eventDate.value;
        var combined=combinedQuantity();
        var message=combined+' '+(combined===1?'chain requires ':'chains require ')+days+' calendar days of advance notice (earliest '+minimum+'), based on this design and custom chains already in your cart.';
        if(combined>24)message='Your combined quantity is '+combined+' custom chains. A quote and confirmed production schedule are required before payment.';
        if(!selected)message+=' Select your needed-by date in Step 6.';
        else if(selected<minimum)message+=' Your selected date ('+selected+') is too early for standard ordering. Return to Step 6 and choose a later date, or request a quote.';
        else message+=' Your selected date ('+selected+') meets the minimum notice requirement; delivery is still subject to confirmation.';
        notice.textContent=message;
        notice.classList.toggle('w3-date-warning',!!selected&&selected<minimum);
      }
    }
    if(eventDate){
      eventDate.min=earliestNeedByDate();
      eventDate.addEventListener('change',function(){
        updateDateRequirements();
        if(eventDate.value&&eventDate.value>=earliestNeedByDate())showError('');
        saveDraft();
      });
    }
    var msg=root.querySelector('[data-w3-error]'),policy=root.querySelector('[data-w3-policy]'),rights=root.querySelector('[data-w3-rights]'),salePolicy=root.querySelector('[data-w3-sale-policy]');
    function value(n){return root.querySelector('[data-w3-'+n+']');}
    function setText(n,s){root.querySelectorAll('[data-w3-'+n+']').forEach(function(e){e.textContent=s;});}
    function price(){var v=variants.find(function(x){return x.colors===count&&x.size===size&&x.style===chainStyle});return v?Number(v.price):BASE[count-1]+(size===7?5:0)-(chainStyle==='Standard Links'?2:0);}
    function money(p){return '$'+Number(p).toFixed(2);}
    function bundleRate(){var q=combinedQuantity();return q>=10?0.20:q>=5?0.15:q>=2?0.10:0;}
    function unitAfterDiscount(){var cents=Math.round(price()*100),percent=Math.round(bundleRate()*100);return (cents-Math.floor(cents*percent/100))/100;}
    function orderPrice(){return Math.round(unitAfterDiscount()*quantity*100)/100;}
    function syncVariant(){
      var v=variants.find(function(x){return x.colors===count&&x.size===size&&x.style===chainStyle});
      var variantField=value('variant');if(variantField)variantField.value=v&&v.id?v.id:'';
      if(value('prop-size'))value('prop-size').value=size+'-inch';
      if(value('prop-style'))value('prop-style').value=chainStyle;
      if(value('prop-count'))value('prop-count').value=count+' '+(count===1?'color':'colors');
      if(value('prop-palette'))value('prop-palette').value=chosen.slice(0,count).join(', ');
      if(value('prop-primary'))value('prop-primary').value=primary.value;
      if(value('prop-secondary'))value('prop-secondary').value=secondary.value;
      if(value('prop-shape'))value('prop-shape').value=pendant.value;
    }
    function refreshPrices(){
      if(form.dataset.submitting==='1')return;
      setText('unit-price',money(price()));
      setText('total',money(orderPrice()));
      setText('side-total',money(orderPrice()));
      setText('bundle-total',money(orderPrice()));
      setText('bundle-per',money(unitAfterDiscount())+' per chain');
      var savings=Math.round((price()*quantity-orderPrice())*100)/100;
      setText('bundle-saved',bundleRate()?'Save '+money(savings)+' ('+Math.round(bundleRate()*100)+'% off)':'No discount yet');
      var quantityInput=value('qty-output');
      if(quantityInput)quantityInput.value=String(quantity);
      setText('side-qty',quantity+' '+(quantity===1?'chain':'chains'));
      setText('review-qty',String(quantity));
      setText('checkout-qty',String(quantity));
      setText('checkout-noun',quantity===1?'chain':'chains');
      var combined=combinedQuantity(),nextTier=combined<2?2:combined<5?5:combined<10?10:null;
      setText('tier-message',combined>24?'Your combined order requires a quote before payment.':nextTier?'Add '+(nextTier-combined)+' more '+(nextTier-combined===1?'chain':'chains')+' to unlock '+(nextTier===2?10:nextTier===5?15:20)+'% off.':'You have unlocked 20% group savings!');
      var context=existingQuantity+' already in your cart + '+quantity+' for this design = '+combined+' custom '+(combined===1?'chain':'chains')+'. The estimate above is for this design only; final discounts, shipping and taxes are confirmed in your cart and checkout.';
      if(combined>24)context+=' A quote is required for the combined order.';
      if(!cartFresh)context+=' We could not refresh your cart. This estimate uses the last known cart quantity; check your cart before ordering.';
      setText('cart-context',context);
      var progress=value('tier-progress');
      if(progress)progress.style.width=Math.min(100,100*combined/(nextTier||10))+'%';
      var cartQuantity=value('cart-quantity');
      if(cartQuantity)cartQuantity.value=String(quantity);
      root.querySelectorAll('[data-w3-qty-preset]').forEach(function(button){
        var tier=quantity>=10?10:quantity>=5?5:quantity>=2?2:1;
        button.setAttribute('aria-pressed',String(Number(button.dataset.w3QtyPreset)===tier));
      });
      var minus=value('qty-minus'),plus=value('qty-plus');
      if(minus)minus.disabled=quantity<=1;
      if(plus)plus.disabled=quantity>=24;
      setText('size-caption',size+'-inch pendant');setText('count-caption',count+' '+(count===1?'color':'colors'));
      setText('count-display',count+' '+(count===1?'color':'colors'));
      setText('chain-colors',primary.value===secondary.value?'Solid '+primary.value:primary.value+' / '+secondary.value);
      setText('side-style',chainStyle.replace(' Links',' links'));
      setText('review-style',chainStyle.replace(' Links',' links'));
      root.querySelectorAll('[data-w3-chain-style]').forEach(function(button){
        button.setAttribute('aria-pressed',String(button.dataset.w3ChainStyle===chainStyle));
      });
      setText('review-price',money(orderPrice()));setText('review-size',size+'-inch');setText('review-count',String(count));
      var premium=value('premium'),standard=value('standard');
      premium.hidden=count<=4;standard.hidden=count>4;
      Array.prototype.forEach.call(root.querySelectorAll('[data-w3-size]'),function(b){b.setAttribute('aria-pressed',String(Number(b.dataset.w3Size)===size));});
      var range=value('range');range.value=String(count);
      value('review-palette').textContent=chosen.slice(0,count).join(', ');
      value('review-chain').textContent=primary.value+(primary.value===secondary.value?' (solid chain)':' + '+secondary.value);
      var rv=value('review-swatches');rv.textContent='';
      chosen.slice(0,count).forEach(function(c){var s=document.createElement('span');s.style.backgroundColor=colorHex(c);s.title=c;rv.appendChild(s);});
      var rim=root.querySelector('[data-w3-ring]');if(rim){rim.style.borderColor=colorHex(primary.value);rim.style.background='repeating-conic-gradient(from 0deg,'+colorHex(primary.value)+' 0deg 14deg,'+colorHex(secondary.value)+' 14deg 27deg)';rim.style.border='18px dashed '+colorHex(primary.value);}
      syncVariant();
      updateDateRequirements();
      saveDraft();
    }
    function opts(select){
      var prev=select.value;select.innerHTML='';
      chosen.slice(0,count).forEach(function(c){var option=document.createElement('option');option.value=c;option.textContent=c;select.appendChild(option);});
      if(chosen.slice(0,count).includes(prev))select.value=prev;
    }
    function rebuildPalette(){
      pick.innerHTML='';
      for(var i=0;i<count;i++){
        (function(index){
          var div=document.createElement('div');div.className='palette-slot';
          var label=document.createElement('label');var dot=document.createElement('span');dot.className='swatch';dot.style.background=colorHex(chosen[index]);
          var title=document.createElement('span');title.textContent='Filament color '+(index+1);
          label.append(dot,title);
          var select=document.createElement('select');select.setAttribute('aria-label','Filament color '+(index+1));
          PALETTE.forEach(function(p){var option=document.createElement('option');option.value=p[0];option.textContent=p[0];select.appendChild(option);});
          select.value=chosen[index];
          select.addEventListener('change',function(){chosen[index]=select.value;dot.style.background=colorHex(select.value);opts(primary);opts(secondary);refreshPrices();});
          div.append(label,select);pick.appendChild(div);
        })(i);
      }
      opts(primary);opts(secondary);
      if(startingSecondary&&count>1){secondary.value=chosen[1];startingSecondary=false;}
      refreshPrices();
    }
    function showError(message){
      if(message){msg.textContent=message;msg.hidden=false;msg.setAttribute('role','alert');msg.tabIndex=-1;msg.focus({preventScroll:true});}
      else{msg.hidden=true;msg.textContent='';}
    }
    function distinct(){return new Set(chosen.slice(0,count)).size===count;}
    function validateStep(n){
      showError('');
      if(n===2&&!file&&!notes.value.trim()){showError('Please upload artwork or describe your design before continuing.');return false;}
      if(n===3&&!distinct()){showError('Choose '+count+' different filament colors. Repeated colors count as one color.');return false;}
      if(n===5||n===6){
        var earliestDate=earliestNeedByDate(),days=minNoticeDays();
        if(eventDate)eventDate.min=earliestDate;
        if(!eventDate||!eventDate.value||eventDate.value<earliestDate){
          if(n>=6){stage=5;render();}
          showError(!eventDate||!eventDate.value?'Please select your required event or needed-by date in Step 6 before continuing.':'For your combined '+combinedQuantity()+' custom chains, your needed-by date must be at least '+days+' calendar days after ordering. Please choose '+earliestDate+' or later in Step 6.');
          if(eventDate)eventDate.focus();
          return false;
        }
      }
      if(n===6&&!distinct()){showError('Please choose distinct filament colors in Step 4.');return false;}
      if(n===6&&(!rights.checked||!policy.checked||!salePolicy||!salePolicy.checked)){showError('Please confirm the artwork permission, proof approval, and custom-order final-sale policies before continuing.');return false;}
      return true;
    }
    function render(moveFocus){
      var artworkBlock=value("artwork-block"),reviewImage=value("review-image"),sidebar=root.querySelector(".layout > .side");
      if(artworkBlock&&reviewImage&&sidebar){if(stage===6){reviewImage.appendChild(artworkBlock);}else{sidebar.insertBefore(artworkBlock,sidebar.firstChild);}}

      slides.forEach(function(x,i){x.hidden=i!==stage});
      root.querySelectorAll('.seg').forEach(function(x,i){
        x.classList.toggle('active',i<=stage);
        x.classList.toggle('is-current',i===stage);
        x.classList.toggle('is-complete',i<stage);
        if(i===stage)x.setAttribute('aria-current','step');else x.removeAttribute('aria-current');
      });
      setText('step-label','Step '+(stage+1)+' of 7');
      setText('step-name',[
        'Choose the number of chains you need.',
        'Choose your pendant size, chain-link style, and color count.',
        'Upload artwork or describe your design idea.',
        'Pick the exact colors for your pendant and chain.',
        'Choose the pendant shape and add special instructions.',
        'Select your requested event or needed-by date.',
        'Review your order and confirm the policies.'
      ][stage]);
      setText('next-label',['Continue to size & pricing →','Continue to your design →','Continue to colors →','Continue to design details →','Continue to event date →','Continue to review →','Continue →'][stage]);
      value('prev').hidden=stage===0;
      value('next').hidden=stage===6;
      value('submit').hidden=stage!==6;
      setText('review-event-date',eventDate&&eventDate.value?eventDate.value:'Not provided');
      setText('checkout-event-date',eventDate&&eventDate.value?eventDate.value:'Not provided');
      setText('review-artwork',file?file.name:(notes.value.trim()?'Text or idea provided':'Not provided'));
      setText('review-shape',pendant.value);
      setText('review-idea',notes.value.trim()||'Not provided');
      setText('review-notes',detail.value.trim()||'None');
      refreshPrices();
      if(moveFocus){
        var heading=slides[stage].querySelector('h2')||value('step-name');
        if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true});}
        var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        root.querySelector('.shell').scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'start'});
      }
    }
    root.querySelectorAll('[data-w3-size]').forEach(function(b){b.addEventListener('click',function(){size=Number(b.dataset.w3Size);refreshPrices();});});
    root.querySelectorAll('[data-w3-chain-style]').forEach(function(button){
      button.addEventListener('click',function(){
        chainStyle=button.dataset.w3ChainStyle;
        refreshPrices();
      });
    });
    value('range').addEventListener('input',function(){count=Number(this.value);rebuildPalette();});
    root.querySelectorAll('[data-w3-qty-preset]').forEach(function(button){
      button.addEventListener('click',function(){
        quantity=Number(button.dataset.w3QtyPreset);
        refreshPrices();
      });
    });
    var quantityInput=value('qty-output');
    function commitQuantity(){
      var raw=quantityInput.value.trim();
      if(raw===''){quantityInput.value=String(quantity);return;}
      var typed=Number(raw);
      if(!Number.isFinite(typed)){quantityInput.value=String(quantity);return;}
      quantity=Math.max(1,Math.min(24,Math.trunc(typed)));
      refreshPrices();
    }
    quantityInput.addEventListener('input',function(){
      if(this.value.trim()!=='')commitQuantity();
    });
    quantityInput.addEventListener('change',commitQuantity);
    quantityInput.addEventListener('blur',commitQuantity);
    quantityInput.addEventListener('keydown',function(event){
      if(event.key==='Enter'){event.preventDefault();commitQuantity();}
    });
    value('qty-minus').addEventListener('click',function(){
      quantity=Math.max(1,quantity-1);
      refreshPrices();
    });
    value('qty-plus').addEventListener('click',function(){
      quantity=Math.min(24,quantity+1);
      refreshPrices();
    });
    primary.addEventListener('change',refreshPrices);secondary.addEventListener('change',refreshPrices);
    pendant.addEventListener('change',refreshPrices);
    input.addEventListener('change',function(){
      file=this.files&&this.files[0]||null;
      if(file&&file.size>10*1024*1024){this.value='';file=null;showError('Please choose an image or PDF smaller than 10 MB.');}
      else showError('');
      setText('file-name',file?file.name:'');
      var fileResult=value('file-result');if(fileResult)fileResult.hidden=!file;
      var art=value('preview-img'),placeholder=value('preview-placeholder'),visual=root.querySelector('.visual');
      if(imgURL){URL.revokeObjectURL(imgURL);imgURL=null;}
      if(file&&/^image\/(jpeg|png|webp|gif)$/.test(file.type)){
        imgURL=URL.createObjectURL(file);
        art.src=imgURL;art.hidden=false;placeholder.hidden=true;
        visual.classList.add('has-artwork');
        visual.style.setProperty('--w3-preview-image','url("'+imgURL+'")');
      }else{
        art.hidden=true;art.removeAttribute('src');placeholder.hidden=false;
        visual.classList.remove('has-artwork');
        visual.style.removeProperty('--w3-preview-image');
      }
    });
    // Only the first step accepts an image; dropped files use the same validation and preview.
    var dropzone=value('dropzone');
    if(dropzone){
      ['dragenter','dragover'].forEach(function(type){dropzone.addEventListener(type,function(e){e.preventDefault();dropzone.classList.add('is-dragover');});});
      ['dragleave','drop'].forEach(function(type){dropzone.addEventListener(type,function(e){e.preventDefault();dropzone.classList.remove('is-dragover');});});
      dropzone.addEventListener('drop',function(e){
        var list=e.dataTransfer&&e.dataTransfer.files;if(!list||!list.length)return;
        try{
          var dt=new DataTransfer();dt.items.add(list[0]);input.files=dt.files;
          input.dispatchEvent(new Event('change',{bubbles:true}));
        }catch(err){showError('Drag and drop is unavailable in this browser. Please click Choose File instead.');}
      });
    }
    notes.addEventListener('input',function(){setText('char-count',notes.value.length+'/500');saveDraft();});
    detail.addEventListener('input',saveDraft);
    input.addEventListener('change',saveDraft);
    setText('char-count',notes.value.length+'/500');
    value('prev').addEventListener('click',function(){stage=Math.max(0,stage-1);render(true);});
    value('next').addEventListener('click',function(){if(!validateStep(stage))return;stage=Math.min(6,stage+1);render(true);});
    var clearDraft=value('clear-draft');
    if(clearDraft)clearDraft.addEventListener('click',function(){try{sessionStorage.removeItem(draftKey);}catch(e){}window.location.reload();});
    window.addEventListener('focus',refreshCart);
    window.addEventListener('pageshow',refreshCart);
    document.addEventListener('cart:updated',refreshCart);
    form.addEventListener('submit',function(ev){
      if(form.dataset.submitting==='1'){ev.preventDefault();return;}
      if(stage!==6){ev.preventDefault();showError('Please complete all seven steps before adding to cart.');return;}
      if(!validateStep(6)){ev.preventDefault();return;}
      if(!distinct()||(!file&&!notes.value.trim())){ev.preventDefault();showError('Please complete your custom chain details before adding to cart.');return;}
      syncVariant();
      if(!value('variant').value){ev.preventDefault();showError('This price combination is not yet available for checkout.');return;}
      ev.preventDefault();
      if(form.dataset.submitting==='1')return;
      saveDraft();
      var submitButton=value('submit');
      var addUrl=new URL(form.action,window.location.href);
      addUrl.pathname=addUrl.pathname.replace(/\/add\/?$/,'/add.js');
      var payload=new FormData(form);
      var controls=Array.prototype.map.call(form.querySelectorAll('input,select,textarea,button'),function(control){return {node:control,disabled:control.disabled};});
      var originalLabel=submitButton.textContent;
      var originalInert=form.inert;
      var controller=new AbortController();
      var timedOut=false;
      var timeout=window.setTimeout(function(){timedOut=true;controller.abort();},45000);
      form.dataset.submitting='1';
      form.setAttribute('aria-busy','true');
      controls.forEach(function(control){control.node.disabled=true;});
      form.inert=true;
      submitButton.textContent='Adding your chain…';
      fetch(addUrl.href,{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:payload,signal:controller.signal})
        .then(function(response){
          return response.json().then(function(result){
            if(!response.ok||result.status>=400)throw new Error(typeof result.description==='string'?result.description:'Shopify could not add this design.');
            if(!result.id&&!(Array.isArray(result.items)&&result.items.length&&result.items.every(function(item){return !!item.id;})))throw new Error('Shopify did not confirm that this design was added.');
            return result;
          });
        })
        .then(function(){
          draftReady=false;
          try{sessionStorage.removeItem(draftKey);}catch(e){}
          window.location.assign((root.dataset.cartUrl||'/cart.js').replace(/\.js(?:\?.*)?$/,''));
        })
        .catch(function(error){
          form.dataset.submitting='0';
          form.removeAttribute('aria-busy');
          form.inert=originalInert;
          controls.forEach(function(control){control.node.disabled=control.disabled;});
          submitButton.textContent=originalLabel;
          showError((timedOut?'Adding your design took too long. Shopify may still have received it.':error.message||'The request could not be completed.')+(draftSaved?' Your design is still saved in this tab.':' Your design is still on this page, but this browser cannot save it. Keep this tab open.')+' Check your cart before trying again if the connection was interrupted.');
        }).finally(function(){window.clearTimeout(timeout);});
    });
    restoreDraft();
    if(requestedQuantity!==null){
      quantity=requestedQuantity;
      try{
        var cleanUrl=new URL(window.location.href);
        cleanUrl.searchParams.delete('bundle');
        window.history.replaceState(window.history.state,'',cleanUrl.href);
      }catch(e){}
    }
    rebuildPalette();
    if(restoredDraft){
      if(chosen.slice(0,count).includes(restoredDraft.primary))primary.value=restoredDraft.primary;
      if(chosen.slice(0,count).includes(restoredDraft.secondary))secondary.value=restoredDraft.secondary;
      var draftNotice=value('draft-notice');
      if(draftNotice){draftNotice.hidden=false;draftNotice.textContent='Your selections and written notes were restored in this tab. Please review your date and confirm the policies again.'+(restoredDraft.hadArtwork?' Please reselect your artwork file; uploaded files cannot be restored after a refresh.':'');}
    }
    draftReady=true;
    setText('char-count',notes.value.length+'/500');
    render();
    refreshCart();
  }
  function bootstrap(){document.querySelectorAll('.w3-config').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bootstrap,{once:true});else bootstrap();
  document.addEventListener('shopify:section:load',bootstrap);
})();

